module.exports = __webpack_public_path__ + "static/media/commercial_project.23524f5c.svg";